var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "file_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.96 59.66h46.08V17.21L42.17 4.34H8.96zm4.08-4.02h37.92v-33.3H36.98V8.36H13.04zM41 13.61v4.71h9.45l-4.71-4.71c-2.59-2.59-4.717-4.71-4.725-4.71S41 11.02 41 13.61",
    clipRule: "evenodd"
  })));
};
export { SvgFile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguOTYwMDEgNTkuNjZINTUuMDRWMTcuMjA5OEw0Mi4xNjk4IDQuMzM5OTdIOC45NjAwMVY1OS42NlpNMTMuMDQgNTUuNjRINTAuOTZWMjIuMzRIMzYuOThWOC4zNTk5N0gxMy4wNFY1NS42NFpNNDEgMTMuNjFWMTguMzJINTAuNDQ5N0w0NS43NCAxMy42MUM0My4xNDk3IDExLjAxOTUgNDEuMDIzNSA4Ljg5OTk3IDQxLjAxNTEgOC44OTk5N0M0MS4wMDY4IDguODk5OTcgNDEgMTEuMDE5NSA0MSAxMy42MVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";